import { render } from "./ResearchAdd.vue?vue&type=template&id=2219704c&scoped=true"
import script from "./ResearchAdd.vue?vue&type=script&lang=js"
export * from "./ResearchAdd.vue?vue&type=script&lang=js"

import "./ResearchAdd.vue?vue&type=style&index=0&id=2219704c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2219704c"]])

export default __exports__